<template>
  <span class="aggregation-table-cell">
    <!-- チェックボックスの場合 -->
    <span
      v-if="isBoolean"
      role="button"
      aria-haspopup="true"
      :aria-expanded="isEditing"
      class="cell-checkbox-wrapper"
      :class="{ 'is-new': isNew }"
      @click.stop.prevent="$emit('click', $event)"
    >
      <span
        aria-hidden="true"
        class="cell-checkbox-icon"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          role="img"
          aria-hidden="true"
          class="cell-checkbox-svg"
        >
          <path :d="checkboxIcon" />
        </svg>
      </span>
    </span>

    <!-- テキスト/数値の場合 -->
    <span
      v-else
      class="cell-text-wrapper"
      :class="{ 'is-new': isNew }"
      @click.stop.prevent="$emit('click', $event)"
    >
      <input
        :value="displayValue"
        :type="isNumber ? 'text' : inputType"
        readonly
        :disabled="disabled"
        class="cell-text-input"
      >
    </span>
  </span>
</template>

<script>
import { computed } from '@vue/composition-api'
import { mdiCheckboxMarked, mdiCheckboxBlankOutline } from '@mdi/js'

export default {
  name: 'AggregationTableCell',
  props: {
    value: {
      type: [String, Number, Boolean],
      default: null,
    },
    isBoolean: {
      type: Boolean,
      default: false,
    },
    isNumber: {
      type: Boolean,
      default: false,
    },
    isNew: {
      type: Boolean,
      default: false,
    },
    isEditing: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    inputType: {
      type: String,
      default: 'text',
    },
    numberText: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const checkboxIcon = computed(() => (
      props.value ? mdiCheckboxMarked : mdiCheckboxBlankOutline
    ))

    const displayValue = computed(() => (
      props.isNumber ? props.numberText : props.value
    ))

    return {
      checkboxIcon,
      displayValue,
    }
  },
}
</script>

<style lang="scss" scoped>
.aggregation-table-cell {
  display: inline-block;
}

.cell-checkbox-wrapper,
.cell-text-wrapper {
  display: inline-block;
  position: relative;
  cursor: pointer;
  padding: 4px 0;
}

.cell-checkbox-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--v-primary-base, #9155FD);
}

.cell-checkbox-svg {
  width: 24px;
  height: 24px;
  fill: currentColor;
}

.cell-text-input {
  background: transparent;
  border: none;
  outline: none;
  color: inherit;
  font: inherit;
  width: 100%;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
}

// 未保存状態のスタイル - GPU合成を促進
.is-new {
  border-bottom: 2px solid #9155FD;
  will-change: border-color;
}
</style>
